// extracted by mini-css-extract-plugin
export var container = "_bw-1";
export var cornerButtonContainer = "_bw-5";
export var disabled = "_bw-2";
export var fileContainer = "_bw-4";
export var hiddenInput = "_bw-3";
export var widthContainer = "_bw-0";